/**
 * Groovy Collection Filter (GCF)
 * Google Flights-style client-side product filtering.
 * Depends on jQuery (already loaded by theme).
 */
(function($) {
  'use strict';

  var GCF = {
    state: {
      type: [],
      style: [],
      priceMin: 0,
      priceMax: Infinity
    },

    // Cache of initial price bounds (set once from slider attributes)
    priceBounds: { min: 0, max: 0 },

    init: function() {
      var $bar = $('#gcf-bar');
      if (!$bar.length) return;

      // Read price bounds from slider inputs
      var $sliderMin = $bar.find('.gcf-slider-min');
      var $sliderMax = $bar.find('.gcf-slider-max');
      if ($sliderMin.length) {
        this.priceBounds.min = parseInt($sliderMin.attr('min'), 10);
        this.priceBounds.max = parseInt($sliderMax.attr('max'), 10);
        this.state.priceMin = this.priceBounds.min;
        this.state.priceMax = this.priceBounds.max;
      }

      this.bindEvents();
      this.updateResultsCount();
    },

    bindEvents: function() {
      var self = this;

      // Use event delegation on body so events survive DOM changes
      $(document).off('.gcf');

      // Chip toggle
      $(document).on('click.gcf', '.gcf-chip', function(e) {
        e.stopPropagation();
        var filterName = $(this).data('filter');
        var $wrapper = $(this).closest('.gcf-chip-wrapper');
        var $dropdown = $wrapper.find('.gcf-dropdown');
        var wasOpen = $dropdown.hasClass('gcf-dropdown--open');

        // Close all dropdowns first
        self.closeAllDropdowns();

        if (!wasOpen) {
          $(this).addClass('gcf-chip--open');

          // On mobile, move dropdown to body to escape overflow:auto parent
          // (iOS Safari breaks position:fixed inside overflow containers)
          if (window.innerWidth < 768) {
            $dropdown.data('gcf-origin', $wrapper);
            $dropdown.appendTo('body');
            // Force reflow so transition animates from translateY(100%)
            $dropdown[0].offsetHeight;
            $dropdown.addClass('gcf-dropdown--open');
            $('#gcf-overlay').addClass('gcf-overlay--visible');
            $('body').css('overflow', 'hidden');
          } else {
            $dropdown.addClass('gcf-dropdown--open');
          }
        }
      });

      // Click outside closes dropdown
      $(document).on('click.gcf', function(e) {
        if (!$(e.target).closest('.gcf-chip-wrapper').length &&
            !$(e.target).closest('.gcf-dropdown').length) {
          self.closeAllDropdowns();
        }
      });

      // Mobile overlay tap closes
      $(document).on('click.gcf', '#gcf-overlay', function() {
        self.closeAllDropdowns();
      });

      // Mobile "Done" button
      $(document).on('click.gcf', '.gcf-sheet-done', function() {
        self.closeAllDropdowns();
      });

      // Prevent dropdown clicks from closing
      $(document).on('click.gcf', '.gcf-dropdown', function(e) {
        e.stopPropagation();
      });

      // Checkbox change
      $(document).on('change.gcf', '[data-filter-group]', function() {
        var group = $(this).data('filter-group');
        self.state[group] = [];
        $('[data-filter-group="' + group + '"]:checked').each(function() {
          self.state[group].push($(this).val());
        });
        self.applyFilters();
      });

      // Price slider input
      $(document).on('input.gcf', '.gcf-slider-input', function() {
        self.handleSliderInput();
      });

      // Clear all
      $(document).on('click.gcf', '#gcf-clear-btn', function() {
        self.clearAll();
      });

      // Escape key closes dropdowns
      $(document).on('keydown.gcf', function(e) {
        if (e.key === 'Escape') {
          self.closeAllDropdowns();
        }
      });
    },

    closeAllDropdowns: function() {
      // Move any body-appended dropdowns back to their original wrapper
      $('.gcf-dropdown').each(function() {
        var $origin = $(this).data('gcf-origin');
        if ($origin) {
          $(this).removeClass('gcf-dropdown--open');
          $(this).appendTo($origin);
          $(this).removeData('gcf-origin');
        }
      });

      $('.gcf-chip').removeClass('gcf-chip--open');
      $('.gcf-dropdown').removeClass('gcf-dropdown--open');
      $('#gcf-overlay').removeClass('gcf-overlay--visible');
      $('body').css('overflow', '');
    },

    handleSliderInput: function() {
      var $min = $('.gcf-slider-min');
      var $max = $('.gcf-slider-max');
      var minVal = parseInt($min.val(), 10);
      var maxVal = parseInt($max.val(), 10);

      // Prevent crossing
      if (minVal > maxVal) {
        if ($(document.activeElement).hasClass('gcf-slider-min')) {
          $min.val(maxVal);
          minVal = maxVal;
        } else {
          $max.val(minVal);
          maxVal = minVal;
        }
      }

      this.state.priceMin = minVal;
      this.state.priceMax = maxVal;

      // Update visual range bar
      this.updateSliderTrack(minVal, maxVal);

      // Update price labels
      $('.gcf-price-min-label').text('$' + Math.floor(minVal / 100));
      $('.gcf-price-max-label').text('$' + Math.ceil(maxVal / 100));

      this.applyFilters();
    },

    updateSliderTrack: function(minVal, maxVal) {
      var range = this.priceBounds.max - this.priceBounds.min;
      if (range <= 0) return;

      var leftPct = ((minVal - this.priceBounds.min) / range) * 100;
      var rightPct = ((maxVal - this.priceBounds.min) / range) * 100;

      $('#gcf-slider-range').css({
        left: leftPct + '%',
        width: (rightPct - leftPct) + '%'
      });
    },

    applyFilters: function() {
      var self = this;
      var visibleCount = 0;
      var totalCount = 0;

      $('.gcf-product-card').each(function() {
        totalCount++;
        var $card = $(this);
        var types = ($card.attr('data-hc-type') || '').split(',').filter(Boolean);
        var styles = ($card.attr('data-hc-style') || '').split(',').filter(Boolean);
        var price = parseInt($card.attr('data-price'), 10) || 0;

        var matchType = self.state.type.length === 0 ||
          self.state.type.some(function(t) { return types.indexOf(t) !== -1; });

        var matchStyle = self.state.style.length === 0 ||
          self.state.style.some(function(s) { return styles.indexOf(s) !== -1; });

        var matchPrice = price >= self.state.priceMin && price <= self.state.priceMax;

        if (matchType && matchStyle && matchPrice) {
          $card.removeClass('gcf-hidden');
          visibleCount++;
        } else {
          $card.addClass('gcf-hidden');
        }
      });

      this.updateChipStates();
      this.updateResultsCount(visibleCount, totalCount);
      this.toggleNoResults(visibleCount === 0 && totalCount > 0);
      this.toggleClearButton();
    },

    updateChipStates: function() {
      var self = this;

      // Type chip
      var typeCount = this.state.type.length;
      var $typeChip = $('[data-filter="type"]');
      $typeChip.toggleClass('gcf-chip--active', typeCount > 0);
      $typeChip.find('.gcf-chip-badge').text(typeCount);

      // Style chip
      var styleCount = this.state.style.length;
      var $styleChip = $('[data-filter="style"]');
      $styleChip.toggleClass('gcf-chip--active', styleCount > 0);
      $styleChip.find('.gcf-chip-badge').text(styleCount);

      // Price chip
      var priceActive = this.state.priceMin > this.priceBounds.min ||
                         this.state.priceMax < this.priceBounds.max;
      var $priceChip = $('[data-filter="price"]');
      $priceChip.toggleClass('gcf-chip--active', priceActive);
      if (priceActive) {
        $priceChip.find('.gcf-chip-text').text(
          '$' + Math.floor(this.state.priceMin / 100) +
          ' – $' + Math.ceil(this.state.priceMax / 100)
        );
        $priceChip.find('.gcf-chip-badge').text('1').parent().addClass('gcf-chip--active');
      } else {
        $priceChip.find('.gcf-chip-text').text('Price');
      }
    },

    updateResultsCount: function(visible, total) {
      var $count = $('#gcf-results-count');
      if (typeof visible === 'undefined') {
        total = $('.gcf-product-card').length;
        visible = total;
      }
      if (this.hasActiveFilters()) {
        $count.text(visible + ' of ' + total + ' results');
      } else {
        $count.text(total + ' results');
      }
    },

    toggleNoResults: function(show) {
      $('#gcf-no-results').toggleClass('gcf-no-results--visible', show);
      $('#gcf-product-grid').toggle(!show);
    },

    toggleClearButton: function() {
      var active = this.hasActiveFilters();
      $('#gcf-clear-btn').toggleClass('gcf-clear-btn--visible', active);
      $('#gcf-divider').toggleClass('gcf-divider--visible', active);
    },

    hasActiveFilters: function() {
      return this.state.type.length > 0 ||
             this.state.style.length > 0 ||
             this.state.priceMin > this.priceBounds.min ||
             this.state.priceMax < this.priceBounds.max;
    },

    clearAll: function() {
      // Reset state
      this.state.type = [];
      this.state.style = [];
      this.state.priceMin = this.priceBounds.min;
      this.state.priceMax = this.priceBounds.max;

      // Uncheck all checkboxes
      $('[data-filter-group]').prop('checked', false);

      // Reset sliders
      $('.gcf-slider-min').val(this.priceBounds.min);
      $('.gcf-slider-max').val(this.priceBounds.max);
      this.updateSliderTrack(this.priceBounds.min, this.priceBounds.max);

      // Reset price labels
      $('.gcf-price-min-label').text('$' + Math.floor(this.priceBounds.min / 100));
      $('.gcf-price-max-label').text('$' + Math.ceil(this.priceBounds.max / 100));

      // Reset price chip text
      $('[data-filter="price"]').find('.gcf-chip-text').text('Price');

      this.applyFilters();
    }
  };

  // Initialize
  $(function() {
    GCF.init();
  });

  // Re-initialize on InstantClick page change
  if (window.InstantClick) {
    InstantClick.on('change', function() {
      GCF.init();
    });
  }

})(jQuery);
